import Highcharts from './_highcharts-base';
import {Options, AxisLabelsFormatterContextObject, SVGRenderer} from 'highcharts';

export default function () {
    $(() => {
        for (const chart of $('.accuracy-speed-chart')) {
            const axisLabels: Array<string> = $(chart).data('axis-labels');
            const seriesData: Array<any> = $(chart).data('series-data');
            const options: Options = {
                chart: {
                    type: 'scatter',
                    inverted: false,
                    width: 600,
                    height: 500,
                    spacingTop: 5,
                    marginTop: 30,
                    spacingBottom: 30,
                    marginRight: 60,
                    marginLeft: 125,
                    plotBorderWidth: 0,
                    events: {
                        load: function () {
                            addAxisLabels(this.renderer, axisLabels);
                        }
                    },
                },
                yAxis: {
                    min: -4,
                    max: 4,
                    tickInterval: 1,
                    lineWidth: 0,
                    lineColor: 'black',
                    gridLineColor: '#E6E6E6',
                    offset: -208,
                    title: {
                        text: null
                    },
                    labels: {
                        useHTML: true,
                        x: -5,
                        style: {
                            fontSize: '9pt',
                            color: 'black'
                        },
                        formatter: function (this: AxisLabelsFormatterContextObject) {
                            return this.value == 0 ? '' : this.value.toString();
                        },
                    },
                    plotLines: [
                        {
                            value: 0,
                            color: 'black',
                            width: 1,
                            zIndex: 4
                        }
                    ]
                },
                xAxis: {
                    gridLineWidth: 1,
                    min: -4,
                    max: 4,
                    tickInterval: 1,
                    lineWidth: 0,
                    lineColor: 'black',
                    offset: -221,
                    opposite: true,
                    labels: {
                        useHTML: true,
                        y: 19,
                        x: -10,
                        style: {
                            fontSize: '9pt',
                            color: 'black'
                        }
                    },
                    plotLines: [
                        {
                            value: 0,
                            color: 'black',
                            width: 1,
                            zIndex: 4
                        }
                    ]
                },
                series: [
                    {
                        // Upper half of the light grey square that marks the area of 2 and -2
                        type: 'area',
                        color: '#d2d3d5',
                        lineWidth: 0,
                        zIndex: 1,
                        marker: {
                            enabled: false
                        },
                        data: [[-2.01, 2], [2, 2]]
                    },
                    {
                        // Lower half of the light grey square that marks the area of 2 and -2
                        type: 'area',
                        color: '#d2d3d5',
                        lineWidth: 0,
                        zIndex: 1,
                        marker: {
                            enabled: false
                        },
                        data: [[-2.01, -2.01], [2, -2.01]]
                    },
                    {
                        // Upper half of the dark grey square that marks the area of 1 and -1
                        type: 'area',
                        color: '#a8a9ad',
                        lineWidth: 0,
                        zIndex: 1,
                        marker: {
                            enabled: false
                        },
                        data: [[-1, 0.98], [0.99, 0.98]]
                    },
                    {
                        // Lower half of the dark grey square that marks the area of 1 and -1
                        type: 'area',
                        color: '#a8a9ad',
                        lineWidth: 0,
                        zIndex: 1,
                        marker: {
                            enabled: false
                        },
                        data: [[-1, -0.99], [0.99, -0.99]]
                    },
                    {
                        type: 'scatter',
                        zIndex: 1000,
                        lineWidth: 0,
                        marker: {
                            symbol: 'circle',
                            fillColor: '#f9001d',
                            radius: 5,
                            lineWidth: 1,
                            lineColor: 'black'
                        },
                        dataLabels: {
                            enabled: true,
                            useHTML: true,
                            allowOverlap: true,
                            x: 11,
                            y: -3,
                            style: {
                                fontWeight: 'bold',
                                fontSize: '10pt',
                                color: 'black',
                                zIndex: 1000
                            },
                            formatter: function () {
                                return this.point.name;
                            }
                        },
                        data: seriesData,
                    },
                ]
            };
            new Highcharts.Chart(
                chart,
                $.extend(true, {}, options, $(chart).data('chart'))
            );
        }
    });
}

function addAxisLabels(renderer: SVGRenderer, axisLables: Array<string>) {
    renderer.label(
        axisLables[0], 305, -5
    ).css({fontSize: '10pt'}).add();
    renderer.label(
        axisLables[1], 558, 240
    ).css({fontSize: '10pt'}).add();
    renderer.label(
        axisLables[2], 290, 480
    ).css({fontSize: '10pt'}).add();
    renderer.label(
        axisLables[3], 57, 240
    ).css({fontSize: '10pt'}).add();
}